import script from "./Last5YearsChart.vue?vue&type=script&setup=true&lang=js"
export * from "./Last5YearsChart.vue?vue&type=script&setup=true&lang=js"

import "./Last5YearsChart.vue?vue&type=style&index=0&id=71a78a46&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71a78a46"]])

export default __exports__